import { render, staticRenderFns } from "./handle_record.vue?vue&type=template&id=cf267268&scoped=true"
import script from "./handle_record.vue?vue&type=script&lang=js"
export * from "./handle_record.vue?vue&type=script&lang=js"
import style0 from "./handle_record.vue?vue&type=style&index=0&id=cf267268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf267268",
  null
  
)

export default component.exports